import SinglePage from '@dex/bubl-dash/src/lib/pages/SinglePage';
import LeagueSeasonDivisionSingleView from './Components/LeagueSeasonDivisionSingleView';
import LeagueSeasonDivisionSingleEdit from './Components/LeagueSeasonDivisionSingleEdit';
import LeagueSeasonDivisionSingleScheduleGames from './Components/LeagueSeasonDivisionSingleScheduleGames';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "View",
        zone: settings.zone,
        path: settings.key + "/:id/view",
        caps: settings.viewCaps,
        component: SinglePage,
        componentProps: {
            getFetch: settings.singleFetch,
            getFetchParams: settings.singleFetchParams,
            header: {
                getTitle: settings.singleTitle,
                getButtons: settings.singleButtons,
                getTabs: settings.singleTabs
            },
            page: LeagueSeasonDivisionSingleView,
        },
    });

    app.addRoute({
        name: settings.key + "Edit",
        zone: settings.zone,
        path: settings.key + "/:id/edit",
        caps: settings.updateCaps,
        component: SinglePage,
        componentProps: {
            getFetch: settings.singleFetch,
            getFetchParams: settings.singleFetchParams,
            header: {
                getTitle: settings.singleTitle,
                getButtons: settings.singleButtons,
                getTabs: settings.singleTabs
            },
            page: LeagueSeasonDivisionSingleEdit,
        },
    });

    app.addRoute({
        name: settings.key + "Schedule",
        zone: settings.zone,
        path: settings.key + "/:id/schedule",
        caps: settings.updateCaps,
        component: SinglePage,
        componentProps: {
            getFetch: settings.singleFetch,
            getFetchParams: settings.singleFetchParams,
            header: {
                getTitle: settings.singleTitle,
                getButtons: settings.singleButtons,
                getTabs: settings.singleTabs
            },
            page: LeagueSeasonDivisionSingleScheduleGames,
        },
    });

}